import React, { useEffect, useState, useContext } from "react";
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from '../../../../AppContext';
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import Buylink from './../../urlshorten_system/buy_link.jsx';
import Login_google from './.././../login';
import { MyContext } from '../../urlshorten_system/index';

const AboutUs = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    // Mảng chứa các lớp border khác nhau cho background
    const borderClasses = [
        'border-2 border-red-400',
        'border-2 border-blue-400',
        'border-2 border-green-400',
        'border-2 border-yellow-400',
        'border-2 border-purple-400',
        'border-2 border-pink-400',
        'border-2 border-indigo-400'
    ];

    const [id_urlshorten_remix_lists, set_id_urlshorten_remix_lists] = useState(null);

    // Hàm lấy ngẫu nhiên một lớp border từ mảng
    const getRandomBorder = () => {
        return borderClasses[Math.floor(Math.random() * borderClasses.length)];
    };

    const { money_link, remix_lists } = useContext(MyContext);
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('Ấn xác nhận vượt link miễn phí');
    const [apikey, setapikey] = useState(false);
    const [datajoptiktok, setDatajoptiktok] = useState('');
    const [hustmediavipro, sethustmediavipro] = useState("");

    useEffect(() => {
        const hustmediaviproValue = Cookies.get("hustmediavipro");
        sethustmediavipro(hustmediaviproValue);
        const myCookieValue = Cookies.get("apikey");
        setapikey(myCookieValue);
    }, []);

    function handleSubmit(event) {
        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        if (!id_urlshorten_remix_lists) {
            alert_error('Chưa chọn kiểu vượt link');
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return;
        }
        const code_item = Cookies.get("code_item");
        const hustmediaviproValue = Cookies.get("hustmediavipro");
        const url = 'https://hust.media/link/load_logic/remix_lists_choose.php';
        axios.get(url, {
          params: {
            code_item: code_item,
            lienket: hustmediaviproValue,
            id_urlshorten_remix_lists: id_urlshorten_remix_lists
          }
        })
        .then(response => gacha_done(response.data))
        .catch(error => errorapi(error));        
    };

    function errorapi(error) {
        alert_error(error);
        setnutxuly(0);
    };

    function gacha_done(info) {
        if (info.status == 0) {
            alert_error(info.message);
            switch_router('/reactapp/reload_page');
        }
        else if (info.status == 1) {
            alert_success(info.message);
            switch_router('/reactapp/reload_page');
        }
        else {
            switch_router('/reactapp/reload_page');
        }
    }
    return (
        <div className="justify-center items-center mt-1">
            {/* <Helmet>
                <title>Hướng dẫn vượt link Hust Media</title>
            </Helmet> */}
            {apikey ? (
                <>
                    <Buylink money={money_link} hustmediavipro={hustmediavipro} />
                </>
            ) : (
                <>
                    <div className="mb-1">
                        <div>Đăng nhập google để nhận link miễn phí</div>
                        <Login_google />
                    </div>
                    <div className="mb-1">Hoặc:</div>
                </>
            )}

            <div className="justify-center items-center flex">
                <div className="max-w-xl bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="px-1 py-3">
                        <div className="font-bold text-base mb-1">Vượt link miễn phí bên dưới</div>
                        <div className="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-3">
                            {remix_lists.map((option) => (
                                <div
                                    key={option.id}
                                    className={`
                                        relative bg-white rounded 
                                        p-1 sm:p-2 
                                        cursor-pointer hover:opacity-75
                                        ${getRandomBorder()} 
                                        flex flex-col justify-center items-center 
                                        min-h-[70px]
                                    `}
                                    onClick={() => set_id_urlshorten_remix_lists(option.id)}
                                >
                                    <h3 className="font-bold text-lg sm:text-xl text-center">{option.name}</h3>
                                    <p className="text-sm sm:text-base text-center">{option.content}</p>

                                    {/* Nếu option đang được chọn thì hiển thị dấu tích */}
                                    {id_urlshorten_remix_lists === option.id && (
                                        <div className="absolute top-0 right-0 m-1 sm:m-2 text-green-500 text-xl sm:text-2xl">
                                            ✔
                                        </div>
                                    )}
                                </div>
                            ))}

                            {id_urlshorten_remix_lists && (() => {
                                const selectedOption = remix_lists.find(option => option.id === id_urlshorten_remix_lists);
                                return (
                                    <div className="mt-2 p-1 border rounded bg-gray-100">
                                        <p>Đã chọn: <span className="font-bold">{selectedOption?.name}</span></p>
                                    </div>
                                );
                            })()}
                        </div>


                        <button disabled={nutxuly === 1} onClick={handleSubmit}
                            className="mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white">
                            <div className="flex items-center justify-between flex-1">
                                {nutxuly === 1 && (
                                    <div className="spinner-border" role="status">
                                        {/* Spinner: Có thể thêm CSS spinner tùy ý */}
                                    </div>
                                )}

                                <span className="text-lg font-medium text-white">
                                    {nutorder}
                                </span>
                                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
